import React from 'react';
import { Github, Linkedin, Mail, Instagram } from 'lucide-react';

const SocialLinks = () => {
  const socialLinks = [
    {
      icon: Github,
      label: 'GitHub',
      href: 'https://github.com/Morty-lab/',
      color: 'hover:bg-gray-800 hover:text-white',
      description: 'Check out my code'
    },
    {
      icon: Linkedin,
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/in/anie-joseph-cabahug/',
      color: 'hover:bg-blue-600 hover:text-white',
      description: 'Professional network'
    },
    {
      icon: Instagram,
      label: 'Instagram',
      href: 'https://www.instagram.com/morty_bot/',
      color: 'hover:bg-blue-400 hover:text-white',
      description: 'Follow for updates'
    },
    {
      icon: Mail,
      label: 'Email',
      href: `mailto:${process.env.REACT_APP_CREATOR_EMAIL || 'hello@aniecabahug.dev'}`,
      color: 'hover:bg-red-500 hover:text-white',
      description: 'Direct contact'
    }
  ];

  return (
    <div>
      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-6">
        Connect With Me
      </h3>
      <div className="grid grid-cols-2 gap-4">
        {socialLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className={`group flex items-center space-x-3 p-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg transition-all duration-300 ${link.color}`}
          >
            <link.icon className="w-5 h-5 text-gray-600 dark:text-gray-400 group-hover:text-current transition-colors" />
            <div>
              <p className="font-medium text-gray-900 dark:text-white group-hover:text-current transition-colors">
                {link.label}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400 group-hover:text-current transition-colors">
                {link.description}
              </p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialLinks;